import { Calendar, CalendarCellProps } from "@progress/kendo-react-dateinputs";
import { useQuery } from "@tanstack/react-query";
import { FC, useCallback, useMemo } from "react";
import contractsApi from "../../api/contracts";
import DateUtility from "../../utilities/dateUtilities";
import { CustomCalendarCell } from "./CustomCalendarCell";

const HolidayCalendar: FC<any> = (props) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["holidays"],
    queryFn: () => contractsApi.getHolidays(),
  });

  const holidays = useMemo(() => data?.holidays || [], [data]);

  const renderCell = useCallback(
    (cellProps: CalendarCellProps) => {
      const value = cellProps.value;
      const isHoliday = holidays.some(
        (holiday: string) => holiday === DateUtility.formatDateYMD(value),
      );
      return <CustomCalendarCell {...cellProps} isHoliday={isHoliday} />;
    },
    [holidays],
  );

  if (isPending) {
    return <div>Loading calendar...</div>;
  }

  if (isError) {
    return <div>Error loading holidays{error instanceof Error ? ": " + error.message : ""}</div>;
  }

  return <Calendar {...props} cell={renderCell} bottomView="month" topView="month" />;
};

export default HolidayCalendar;
